export const getFullName = (user) => {
    return `${user.firstName} ${user.lastName?.toUpperCase()}`
}